export const getNodePageY = (node) => node.getBoundingClientRect().top + window.scrollY;
